<div class="ppm">
  <section>
    <h6 class="ppm-title">
      Giá theo nhóm khách và miền (đ)
      <app-info-tooltip text="Giá niêm yết trong từng bảng giá, không phụ thuộc người đang xem. Nhóm khách xác định theo điều kiện role của bảng giá: MT là khách thường (không role), MV là role Vip, MC là role KHCL. Chưa gồm voucher."></app-info-tooltip>
    </h6>
    <div class="table-responsive">
      <table class="table table-sm ppm-table">
        <thead>
          <tr>
            <th>Nhóm khách</th>
            <th>Miền</th>
            <th class="num">W1 <app-info-tooltip text="Giá trong bảng giá niêm yết của miền (bảng base). N/A là sản phẩm chưa có dòng trong bảng."></app-info-tooltip></th>
            <th class="num">W2 <app-info-tooltip text="Giá khuyến mãi không giới hạn số lượng (bảng W2). N/A là sản phẩm không có trong bảng."></app-info-tooltip></th>
            <th class="num">W2 Limit <app-info-tooltip text="Giá khuyến mãi có hạn mức số lượng. Bán hết hạn mức thì giá rơi về W2 hoặc W1."></app-info-tooltip></th>
            <th>Hạn mức Limit <app-info-tooltip text="Số còn lại / tổng hạn mức hiện tại. Số đã bán đếm từ lúc bắt đầu bảng Limit của miền, lấy từ dịch vụ đơn hàng (cache tối đa 5 phút), tính cả đơn đã hủy."></app-info-tooltip></th>
            <th class="num">Đang bán <app-info-tooltip text="Giá khách thấy theo bảng giá: mức rẻ nhất còn hạn mức. Chưa gồm giá ướm voucher."></app-info-tooltip></th>
            <th>Ghi chú</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let segment of segments">
            <tr *ngFor="let region of regions; let first = first" [class.ppm-group-start]="first">
              <!-- Ô nhãn nhóm khách nằm ngoài *ngIf của ô giá để rowspan luôn khớp số dòng dù thiếu ô giá -->
              <td class="seg" *ngIf="first" [attr.rowspan]="regions.length">{{ segmentLabels[segment] }}</td>
              <ng-container *ngIf="cell(segment, region) as c">
                <td>{{ regionLabels[region] }}</td>
                <td class="num" [class.na]="c.base === null">{{ price(c.base) }}</td>
                <td class="num" [class.na]="c.promo === null">{{ price(c.promo) }}</td>
                <td class="num" [class.na]="!c.limited">{{ price(c.limited?.price) }}</td>
                <td [class.na]="!c.limited">{{ c.limited ? limitText(c) : '—' }}</td>
                <td class="num eff">
                  <span *ngIf="!c.sellable" class="na">Không bán</span>
                  <ng-container *ngIf="c.sellable"><b>{{ price(c.effective) }}</b> <small *ngIf="c.effectiveSource">{{ c.effectiveSource }}</small></ng-container>
                  <i class="ri-time-line ppm-warn-icon" *ngIf="c.effectiveOutsideValidity" title="Giá lấy từ bảng ngoài thời gian hiệu lực nhưng vẫn được tính."></i>
                </td>
                <td>
                  <span class="ppm-flag" *ngIf="!c.sellable"><i class="ri-forbid-line"></i> {{ reasonLabel(c.notSellableReason) }}</span>
                  <span class="ppm-flag ppm-flag--warn" *ngIf="c.effectiveOutsideValidity"><i class="ri-time-line"></i> Giá đang bán lấy từ bảng ngoài thời gian hiệu lực (hết hạn hoặc chưa tới ngày) nhưng vẫn được tính</span>
                  <span class="ppm-flag ppm-flag--warn" *ngIf="c.limited && !c.soldKnown"><i class="ri-error-warning-line"></i> Chưa lấy được số đã bán, giá đang bán có thể chưa chính xác</span>
                </td>
              </ng-container>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </section>

  <section>
    <h6 class="ppm-title">
      Thông tin phụ sản phẩm theo miền
      <app-info-tooltip text="Lấy từ ProductMeta của sản phẩm (cùng nguồn với mục Thông tin phụ ở trang sửa sản phẩm). Trạng thái bán đã tính đủ: ẩn bán, thiếu giá niêm yết, chính sách bán chặn, Ecom báo hết hàng."></app-info-tooltip>
    </h6>
    <div class="table-responsive">
      <table class="table table-sm ppm-table">
        <thead>
          <tr>
            <th>Miền</th>
            <th>Trạng thái bán <app-info-tooltip text="Bán được hay không trên Ecom ở miền này theo giá niêm yết của nhóm MT. Nếu không bán được thì hiện lý do."></app-info-tooltip></th>
            <th class="num">Tồn Ecom <app-info-tooltip text="Số lượng khả dụng ERP gửi sang (StockStatusByRegions của ProductMeta)."></app-info-tooltip></th>
            <th>Trạng thái tồn</th>
            <th class="num">Tối đa / đơn <app-info-tooltip text="Giới hạn số lượng một đơn (ProductOrderLimitByRegion). Giới hạn đè theo role nếu có ghi ở cột Theo role."></app-info-tooltip></th>
            <th class="num">Tối đa / ngày</th>
            <th>Theo role</th>
            <th class="num">Ngưỡng bất thường</th>
            <th class="num">VAT (%)</th>
            <th class="num">Lead time (ngày)</th>
            <th class="num">Bán TB 30 ngày</th>
            <th>Hạn dùng</th>
            <th>Nhãn</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let region of regions">
            <ng-container *ngIf="regionInfo(region) as r">
              <td>{{ regionLabels[region] }}</td>
              <td>
                <span class="ppm-ok" *ngIf="!r.saleBlockKey"><i class="ri-checkbox-circle-line"></i> Bán được</span>
                <span class="ppm-flag" *ngIf="r.saleBlockKey" [title]="r.saleBlockDetail || ''"><i class="ri-forbid-line"></i> {{ r.saleBlockLabel }}</span>
              </td>
              <td class="num">{{ num(r.quantity) }}</td>
              <td>{{ statusLabel(r.stockStatus) }}</td>
              <td class="num">{{ limitUnlimited(r.maxOrderQuantityPerOrder) }}</td>
              <td class="num">{{ limitUnlimited(r.maxOrderQuantityPerDay) }}</td>
              <td>{{ r.roleOrderLimits.length ? roleLimitText(r) : '—' }}</td>
              <td class="num">{{ num(r.abnormalLimit) }}</td>
              <td class="num">{{ num(r.vat) }}</td>
              <td class="num">{{ num(r.leadTimeDays) }}</td>
              <td class="num">{{ num(r.avgDailySalesQty30Days) }}</td>
              <td>{{ r.expirationDate ? (r.expirationDate | date:'dd/MM/yyyy') : '—' }}</td>
              <td>{{ r.tags.length ? r.tags.join(', ') : '—' }}</td>
            </ng-container>
          </tr>
        </tbody>
      </table>
    </div>
    <p class="ppm-note" *ngIf="row.packagingSpecifications"><b>Quy cách đóng gói:</b> {{ row.packagingSpecifications }}</p>
  </section>
</div>
